export const ISSERVER = typeof window === "undefined"
